import { serializeData } from "../../../utils/utils"
import type { LeadsFilters } from "./leads.types.ts"

/** The leads list's filters as the API reads them. The shared serializer drops
 *  the value "all" (an unset "All" choice everywhere else), but here
 *  `view=all` is a real view — the one a dashboard drill needs so archived
 *  leads it counted are listed — so it is put back. A drill's dashboard
 *  filters travel as their own `dash_*` / `wdash_*` parameters. */
export const buildLeadsRequestParams = (filters: LeadsFilters): LeadsFilters => {
  const { dashboard_filters: dashboardFilters, ...rest } = filters
  const params = serializeData(rest) as LeadsFilters
  return {
    ...params,
    ...(dashboardFilters ?? {}),
    ...(filters.view === "all" ? { view: "all" as const } : {})
  }
}
